<template>
  <div class="modal-message">
    <div class="card col-md-12" v-loading="loading" element-loading-spinner="qc-spinner">
      <div class="card-header">
        <h4 class="card-title">Download Reports</h4>
      </div>
      <div class="card-content row">
        <div class="form-horizontal">
          <div  v-if="this.$store.state.applicationTemplateIds.length > 0" class="form-group">
            <label class="col-sm-2 control-label">Report Type <span class="text-danger">*</span></label>
            <div class="col-sm-10 report-type" >
              <div :class="{ 'selected-report-type' : isApplicationType }" @click="onApplicationReportType">Applications Report</div>
              <div :class="{ 'selected-report-type' : !isApplicationType }" @click="onVerificationReportType">Verifications Report</div>
            </div>
          </div>
          <div class="form-group" v-if="isApplicationType">
            <label class="col-sm-2 control-label">Applications <span class="text-danger">*</span></label>
            <div class="col-sm-10">
              <el-select
                name="applications"
                placeholder="Select"
                collapse-tags
                v-model="selectedTemplate"
                value-key="value"
              >
                <el-option-group
                  v-if="this.$store.state.applicationTemplateIds.length > 0"
                  :label="'Select Application(s) for overview data'"
                >
                  <el-option
                    v-for="item in applicationOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-option-group>
              </el-select>
            </div>
          </div>
          <div class="form-group">
            <label class="col-sm-2 control-label">Report <span class="text-danger">*</span></label>
            <div class="col-sm-10">
              <el-select v-model="report">
                <el-option key="monthlyoverview" value="monthlyoverview" label="Monthly Overview" />
                <el-option key="rejecteds" value="rejecteds" label="All Action Required" />
                <el-option key="pendings" value="pendings" label="All Pending" />
                <el-option key="successrates" value="successrates" label="Success Rates" />
              </el-select>
            </div>
          </div>
          <div v-if="needDates" class="form-group">
            <label class="col-sm-2 control-label">Dates <span class="text-danger">*</span></label>
            <div class="col-sm-10">
              <el-date-picker
                v-model="dateRange"
                type="daterange"
                size="large"
                :editable="false"
                start-placeholder="Start date"
                end-placeholder="End date"
                value-format="yyyy-MM-dd"
                :picker-options="pickerOptions">
              </el-date-picker>
              <span class="help-block">Show only verifications on or between these dates.</span>
            </div>
          </div>
        </div>
      </div>
      <div class="card-footer row">
        <div class="col-md-12">
          <button @click="$modal.close()" class="btn">Close</button>
          <button @click="download" class="btn btn-fill btn-wd pull-right"><i class="fa fa-download"/> Download</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { utils, writeFile } from 'xlsx'
  import {DatePicker} from 'element-ui'
  import ApplicationTemplateMultiSelect from "src/components/Inputs/ApplicationTemplateMultiSelect";

  export default {
    name: 'modal-verification-transfer',
    components: {
      [DatePicker.name]: DatePicker,
      ApplicationTemplateMultiSelect
    },
    props: {

    },
    data () {
      return {
        selectedTemplate: null,
        isApplicationType: true,
        applicationOptions: [],
        loading: false,
        needDates: true,
        report: null,
        dateRange: [],
        pickerOptions: {
          disabledDate (date) {
            return date > new Date()
          },
          shortcuts: [
            {
              text: 'This month',
              onClick(picker) {
                var date = new Date(), y = date.getFullYear(), m = date.getMonth();
                const start = new Date();
                const end = new Date();
                start.setFullYear(y, m, 1);
                picker.$emit('pick', [start, end]);
              }
            },
            {
              text: 'Last month',
              onClick(picker) {
                var date = new Date(), y = date.getFullYear(), m = date.getMonth();
                const start = new Date();
                const end = new Date();
                start.setFullYear(y, m-1, 1);
                end.setFullYear(y, m, 0);
                picker.$emit('pick', [start, end]);
              }
            },
            {
              text: 'Last 12 months',
              onClick(picker) {
                const end = new Date();
                const start = new Date();
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 365);
                picker.$emit('pick', [start, end]);
              }
            }
          ]
        }
      }
    },
    mounted: function () {
      this.loading = true
      this.constructOptions()
      this.loading = false
    },
    watch: {
      report(value) {
        this.needDates = value == 'monthlyoverview' || value == 'successrates'
        this.dateRange = []
      }
    },
    methods: {
      onVerificationReportType() {
        this.isApplicationType = false
        this.selectedTemplate = null
      },
      onApplicationReportType() {
        this.isApplicationType = true
        this.selectedTemplate = null

      },
      constructOptions() {
        const templates = this.$store.state.applicationTemplateIds
        if(templates.length > 0) {
          this.applicationOptions = [
            {
              value: -1,
              label: 'All Applications'
            },
            ...templates.map((template) => {
              return {
                value: template.id,
                label: template.name
              }
            })
          ]
        }
      },
      download() {
        if(this.report == null) {
          this.$snotify.error("Select a report to download.", "Oops!", {timeout: 2500})
          return
        }
        if(this.needDates && this.dateRange.length == 0) {
          this.$snotify.error("This report needs a date range selected.", "Oops!", {timeout: 2500})
          return
        }
        if(this.isApplicationType && this.selectedTemplate == null) {
          this.$snotify.error("This report needs a selected Application Template).", "Oops!")
        }
        this.loading = true
        this.$api.getReport(this.report, this.dateRange, this.selectedTemplate)
          .then(response => {
              console.log(response.data)
              const worksheet = utils.json_to_sheet(response.data);
              const workbook = utils.book_new()
              var sheetName = 'Data'
              var fileName = 'Download.xlsx'
              if(this.report == 'monthlyoverview') {
                sheetName = "Monthly Overview"
                fileName = "MonthlyOverview.xlsx"
              } else if(this.report == 'rejecteds') {
                sheetName = "All Action Required"
                fileName = "AllActionRequired.xlsx"
              } else if(this.report == 'pendings') {
                sheetName = "All Pending"
                fileName = "AllPending.xlsx"
              } else if(this.report == 'successrates') {
                sheetName = "Success Rates"
                fileName = "SuccessRates.xlsx"
              }
              utils.book_append_sheet(workbook, worksheet, sheetName)
              writeFile(workbook, fileName)
              this.loading = false
          })
          .catch(error => {
              console.log(error)
              this.loading = false
          })
      }
    }
  }
</script>

<style>
 .report-type {
   display: flex;
   gap: 15px;
   padding-top: 10px;
 }

 .report-type > div {
   font-size: 16px;
   color: #3BA5AA;
   cursor: pointer;
 }

 .report-type >div:hover {
   color: #28465A !important;
 }

 .selected-report-type {
   text-decoration: underline;
   font-weight: 600;
   color: #28465A !important;
   cursor: default !important;
 }
</style>
